import { FC } from 'react'
import { Text } from '../../../components/UI'

type TextSummaryProps = {
  className?: string
}

const TextSummary:FC<TextSummaryProps> = ({ children, className = '' }) => {
  return (
    <Text className={className}>{children}</Text>
  )
}

export { TextSummary }
